'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('formio', []);